<template>
  <div>
    <div class="help_Info_right fr">
      <div class="help_Info_right_top fl">退款说明</div>
      <div class="help_Info_right_bootm shoppstep fl">
        <dl>
          <dt>退款说明</dt>
          <dd>
            1)经审核通过的退款申请，在客户退回的商品经仓库检验合格的情况下，收到退回商品之日起3-5个工作日内退款给客户。
            若检验未合格不予退款。此外，由于客户递交退款申请及商品退回的延迟，以及银行等第三方支付平台办理退款周期的原因，不排除退款时间延迟的可能。"
          </dd>
          <dd>2)在西始以任何支付方式的订单退款均以原路退回的方式退款。</dd>
          <dd>3)申请退款时需将打款账户及相关信息反馈给商务或者售后人员，以便及时办理您的退款。</dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "refundment"
};
</script>

<style>
</style>
